module.exports = __webpack_public_path__ + "static/img/817_phase_function_Paper_Points.9c78eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/817_phase_function_Paper_Points.png
// module id = dcGq
// module chunks = 0